import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from "react-helmet-async";
import { Provider } from 'react-redux';
import store from './store/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </HelmetProvider>
  // </React.StrictMode>
);

// const root = ReactDOM.hydrateRoot(document.getElementById("root"), (
//   <HelmetProvider>
//     <Provider store={store}>
//       <App />
//     </Provider>
//   </HelmetProvider>
// ));

reportWebVitals();
